import React, { useState, useEffect } from 'react'
import { Box, TextField } from '@material-ui/core'

export const DurationInput = ({ value, onChange, disabled, useLabel }) => {
  const totalSeconds = Number(value) || 0
  const [d, setD] = useState(Math.floor(totalSeconds / 86400))
  const [h, setH] = useState(Math.floor((totalSeconds % 86400) / 3600))
  const [m, setM] = useState(Math.floor((totalSeconds % 3600) / 60))
  const [s, setS] = useState(totalSeconds % 60)

  useEffect(() => {
    const v = Number(value) || 0
    setD(Math.floor(v / 86400))
    setH(Math.floor((v % 86400) / 3600))
    setM(Math.floor((v % 3600) / 60))
    setS(v % 60)
  }, [value])

  const handleChange = (newD, newH, newM, newS) => {
    setD(newD)
    setH(newH)
    setM(newM)
    setS(newS)
    const total =
      (parseInt(newD) || 0) * 86400 +
      (parseInt(newH) || 0) * 3600 +
      (parseInt(newM) || 0) * 60 +
      (parseInt(newS) || 0)
    onChange && onChange(total)
  }

  return (
    <Box display="flex" alignItems="center" gap={1} style={{ marginTop: useLabel ? '1.2rem' : 0 }}>
      <TextField
        type="number"
        label="Days"
        value={d}
        onChange={e => handleChange(e.target.value, h, m, s)}
        inputProps={{ min: 0 }}
        style={{ width: 70, marginRight: 8 }}
        disabled={disabled}
      />
      <TextField
        type="number"
        label="Hours"
        value={h}
        onChange={e => handleChange(d, e.target.value, m, s)}
        inputProps={{ min: 0 }}
        style={{ width: 70, marginRight: 8 }}
        disabled={disabled}
      />
      <TextField
        type="number"
        label="Minutes"
        value={m}
        onChange={e => handleChange(d, h, e.target.value, s)}
        inputProps={{ min: 0, max: 59 }}
        style={{ width: 90, marginRight: 8 }}
        disabled={disabled}
      />
      <TextField
        type="number"
        label="Seconds"
        value={s}
        onChange={e => handleChange(d, h, m, e.target.value)}
        inputProps={{ min: 0, max: 59 }}
        style={{ width: 90 }}
        disabled={disabled}
      />
    </Box>
  )
}

export default DurationInput